import React from "react";
import {} from "../icons";
import AccordionInfo from "./AccordionInfo";

const ReportLists = ({
  data,
  infoView,
  showInfo,
  groupSelectStatus,
  selectedRange,
}) => {
  return (
    <div className="w-full flex flex-col gap-4">
      {data &&
        data?.map((lists, index) => {
          return (
            <div key={`${lists?.device} ${index}`}>
              <AccordionInfo
                information={lists}
                index={index}
                infoView={infoView}
                showInfo={showInfo}
                groupSelectStatus={groupSelectStatus}
                selectedRange={selectedRange}
              />
            </div>
          );
        })}
    </div>
  );
};

export default ReportLists;
